import api from '@/apis/di/toolTypeAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('toolType', api);

const state = {
  ...crud.state,
  _config: {
    //TODO: Tên bảng call api
    table: 'di_inventory_category',
    field: {
      key: 'inventory_category_id',
      code: 'inventory_category_code',
      name: 'inventory_category_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
